import styled from 'styled-components';

import { Color } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { InputValueBoxBaseStyle } from '../../theme';

import { InputContainerProps } from './textarea.types';

export const Container: StyledComponent<'div'> = styled.div``;

export const InputContainer: StyledComponent<'fieldset', InputContainerProps> = styled.fieldset<InputContainerProps>`
  position: relative;
  ${InputValueBoxBaseStyle}
  padding: ${({ $isCharsCounterActive }: InputContainerProps): string => `18px 16px ${$isCharsCounterActive ? '36px' : '18px'} 16px`};
  height: 140px;
`;

export const BaseTextarea: StyledComponent<'textarea'> = styled.textarea`
  width: 100%;
  height: 100%;
  border: none;
  resize: none;
  background-color: ${Color.Transparent};
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;

  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const CharsCounter: StyledComponent<'div'> = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${Color.Gray500};
  position: absolute;
  bottom: 12px;
  left: 16px;
`;
